import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ContactMessage, ContactService } from './contact.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  standalone: false
})

/**
 * Contact Component
 */
export class ContactComponent implements OnInit {
  loadingSubmit: boolean = false; 
  constructor(private toastr: ToastrService,public translate:TranslateService,
    private contactService: ContactService
  ) { }

  ngOnInit(): void { }

  onSubmit(form: NgForm): void {
    if (!form.valid) {
      this.toastr.error(
        this.translate.instant('general.fillAllFields'),
        this.translate.instant('general.formIncomplete')
      );
      return;
    }

    // Check localStorage for last message timestamp
    const lastTimestampStr = localStorage.getItem('lastMessageTimestamp');
    const now = Date.now();
    if (lastTimestampStr) {
      const lastTimestamp = parseInt(lastTimestampStr, 10);
      const diffMs = now - lastTimestamp;
      if (diffMs < 120000) {
        this.toastr.error(
          this.translate.instant('general.pleaseWaitAtLeast2minutes'),
          this.translate.instant('general.tooSoon')
        );
        return;
      }
    }

    // Set loading flag
    this.loadingSubmit = true;

    // Prepare message data
    const contactMessage: ContactMessage = {
      name: form.value.name,
      email: form.value.email,
      subject: form.value.subject,
      message: form.value.comments
    };

    // Call the service to send the message
    this.contactService.sendMessage(contactMessage).subscribe({
      next: (response) => {
        localStorage.setItem('lastMessageTimestamp', now.toString());
        this.toastr.success(
          this.translate.instant('general.messageSent'),
          this.translate.instant('general.success')
        );
        this.loadingSubmit = false;
        form.resetForm();
      },
      error: (error) => {
        this.toastr.error(
          this.translate.instant('general.errorSendingMessage'),
          this.translate.instant('general.error')
        );
        this.loadingSubmit = false;
      }
    });
  }
}
